import { useEffect } from 'react';

import { useDocumentTitle } from 'hooks/document-title';
import ReactGA from 'react-ga4';

import { Error } from './Error';

const Error400 = () => {
  useDocumentTitle('Bad Request | Checkmate');

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname,
      title: '400 Bad Request',
    });
  }, []);

  return <Error>400</Error>;
};

export default Error400;
